import { Link } from "@inertiajs/react"
import { useGitlabStatus } from "@/lib/gitlabStatus"

export default function TokenBanner() {
  const response = useGitlabStatus(true)
  if (!response || !("error" in response) || response.error !== "token") return null

  return (
    <section aria-label="GitLab token problem" className="mx-auto mb-2 max-w-page px-4">
      <p className="flex flex-wrap items-center justify-between gap-2 rounded-surface bg-red-50 px-4 py-3 text-sm font-medium text-red-900 dark:bg-red-950 dark:text-red-100">
        GitLab rejected your personal access token, so scheduled statuses can't be posted.
        <Link href="/users/edit" className="underline">
          Update your token
        </Link>
      </p>
    </section>
  )
}
